module.exports = __webpack_public_path__ + "img/gzhj_13.0a370687.jpg";